import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TransaccionModel } from '../transaccion.model';
import { AcreditacionService } from 'src/app/services/administracion/acreditacion.service';
import { IResponse } from 'src/app/pages/base/interfaces';

export class Acreditacion extends TransaccionModel {
    public static RECORD_NAME = 'acreditaciones';
    public static CODIGO_REGISTRO = 'acreditacion';
    public static CODIGO_MODULO = 'administracion';
    public static NOMBRE_SINGULAR = 'Acreditación';
    public static NOMBRE_PLURAL = 'Acreditaciones';

    public static TIPO_ADMINISTRACION = 1;
    public static TIPO_DEPOSITO_BANCARIO = 2;
    public static TIPO_TRANSAFERENCIA = 3;

    public static BANCO_UENO = 1;
    public static BANCO_CONTINENTAL = 2;
    public static BANCO_GNB = 3;

    public static ACREDITACION_PARA_EMPRESA = 1;
    public static ACREDITACION_PARA_SUCURSAL = 2;

    public static ENABLE_FIELDS: string[] = ['fecha_transaccion'];
    public static DISABLE_FIELDS: string[] = ['fecha_transaccion'];

    public static TIPOS = [
        { valor: 1, nombre: 'ADMINISTRACION' },
        { valor: 2, nombre: 'DEPOSITO BANCARIO' },
        { valor: 3, nombre: 'TRANSFERENCIA' },
    ];

    public static BANCOS = [
        { valor: 1, nombre: 'UENO' },
        { valor: 2, nombre: 'CONTINENTAL' },
        { valor: 3, nombre: 'GNB' },
    ];

    public static ACREDITACION_PARA = [
        { valor: Acreditacion.ACREDITACION_PARA_EMPRESA, nombre: 'La Empresa' },
        {
            valor: Acreditacion.ACREDITACION_PARA_SUCURSAL,
            nombre: 'Una Sucursal',
        },
    ];

    private _idEmpresa: number;
    private _nombreEmpresa: string;
    private _idSucursal: number;
    private _nombreSucursal: string;
    private _tipo: number;
    private _nroComprobante: string;
    private _comentario: string;
    private _importe: number;
    private _banco: number;
    private _consCredAnterior: number;
    private _limCredAnterior: number;
    private _disCredAnterior: number;
    private _fechaAprobacion: Date;
    private _acreditacionPara: number;

    constructor() {
        super();
        const currentUser = this.seguridad.getCurrentUser();
        this._idEmpresa = currentUser.id_empresa;
        this._nombreEmpresa = currentUser.empresa.nombre;
        this._idSucursal = currentUser.id_sucursal;
        this._nombreSucursal = currentUser.sucursal.nombre;
        this._tipo = Acreditacion.TIPO_ADMINISTRACION;
        this._banco = Acreditacion.BANCO_UENO;
        this._importe = 0;
        this._consCredAnterior = 0;
        this._limCredAnterior = 0;
        this._disCredAnterior = 0;
        this._acreditacionPara = Acreditacion.ACREDITACION_PARA[0].valor;
    }

    public set idEmpresa(idEmpresa: number) {
        this._idEmpresa = idEmpresa;
    }
    public get idEmpresa(): number {
        return this._idEmpresa;
    }

    public set nombreEmpresa(nombreEmpresa: string) {
        this._nombreEmpresa = nombreEmpresa;
    }
    public get nombreEntidad(): string {
        return this._nombreEmpresa;
    }

    public set idSucursal(idSucursal: number) {
        this._idSucursal = idSucursal;
    }
    public get idSucursal(): number {
        return this._idSucursal;
    }

    public set nombreSucursal(nombreSucursal: string) {
        this._nombreSucursal = nombreSucursal;
    }
    public get nombreSucursal(): string {
        return this._nombreSucursal;
    }

    public set comentario(comentario: string) {
        this._comentario = comentario;
    }
    public get comentario(): string {
        return this._comentario;
    }

    public set importe(importe: number) {
        this._importe = importe;
    }
    public get importe(): number {
        return this._importe;
    }

    public set tipo(tipo: number) {
        this._tipo = tipo;
    }
    public get tipo(): number {
        return this._tipo;
    }

    public set nroComprobante(nroComprobante: string) {
        this._nroComprobante = nroComprobante;
    }
    public get nroComprobante(): string {
        return this._nroComprobante;
    }

    public set banco(banco: number) {
        this._banco = banco;
    }
    public get banco(): number {
        return this._banco;
    }

    public set consCredAnterior(consCredAnterior: number) {
        this._consCredAnterior = consCredAnterior;
    }
    public get consCredAnterior(): number {
        return this._consCredAnterior;
    }

    public set limCredAnterior(limCredAnterior: number) {
        this._limCredAnterior = limCredAnterior;
    }
    public get limCredAnterior(): number {
        return this._limCredAnterior;
    }

    public set fechaAprobacion(fechaAprobacion: Date) {
        this._fechaAprobacion = fechaAprobacion;
    }

    public get fechaAprobacion(): Date {
        return this._fechaAprobacion;
    }

    public set acreditacionPara(acreditacionPara: number) {
        this._acreditacionPara = acreditacionPara;
    }

    public get acreditacionPara(): number {
        return this._acreditacionPara;
    }

    public set disCredAnterior(disCredAnterior: number) {
        this._disCredAnterior = disCredAnterior;
    }
    public get disCredAnterior(): number {
        return this._disCredAnterior;
    }

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'nro_transaccion', label: 'Nro. Trx.', type: 'number' },
            { field: 'fecha_transaccion', label: 'Fecha Trx.', type: 'date' },
            { field: 'nro_comprobante', label: 'Comprobante', type: 'text' },
            { field: 'importe', label: 'Monto', type: 'number' },
        ];
    }

    override async cargarObjeto(objeto: Record<string, any>) {
        await super.cargarObjeto(objeto);
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.empresa.nombre;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.sucursal.nombre;
        this._importe = objeto.importe;
        this._banco = objeto.banco;
        this._nroComprobante = objeto.nro_comprobante;
        this._tipo = objeto.tipo;
        this._comentario = objeto.comentario;
        this._consCredAnterior = objeto.cons_cred_anterior;
        this._limCredAnterior = objeto.lim_cred_anterior;
        this._disCredAnterior = objeto.dis_cred_anterior;
        this._fechaAprobacion = objeto.fecha_aprobacion;
        this._acreditacionPara = objeto.acreditacion_para;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();

        fg.addControl(
            'id_empresa',
            new FormControl(this._idEmpresa, Validators.required)
        );

        fg.addControl(
            'nombre_empresa',
            new FormControl(this._nombreEmpresa, Validators.required)
        );

        fg.addControl(
            'id_sucursal',
            new FormControl(this._idSucursal, Validators.required)
        );

        fg.addControl(
            'nombre_sucursal',
            new FormControl(this._nombreSucursal, Validators.required)
        );

        fg.addControl(
            'nro_comprobante',
            new FormControl(this._nroComprobante, Validators.required)
        );

        fg.addControl(
            'importe',
            new FormControl(this._importe, Validators.required)
        );

        fg.addControl('comentario', new FormControl(this._comentario));

        fg.addControl('tipo', new FormControl(this._tipo));

        fg.addControl('banco', new FormControl(this._banco));

        fg.addControl(
            'cons_cred_anterior',
            new FormControl(this._consCredAnterior)
        );

        fg.addControl(
            'lim_cred_anterior',
            new FormControl(this._limCredAnterior)
        );

        fg.addControl(
            'fecha_aprobacion',
            new FormControl(this._fechaAprobacion)
        );

        fg.addControl(
            'acreditacion_para',
            new FormControl(this._acreditacionPara)
        );

        fg.addControl(
            'dis_cred_anterior',
            new FormControl(this._disCredAnterior)
        );

        return fg;
    }

    override async actualizarDatos(objeto: Record<string, any>) {
        await super.actualizarDatos(objeto);
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.nombre_sucursal;
        this._importe = objeto.importe;
        this._banco = objeto.banco;
        this._nroComprobante = objeto.nro_comprobante;
        this._tipo = objeto.tipo;
        this._comentario = objeto.comentario;
        this._consCredAnterior = objeto.cons_cred_anterior;
        this._limCredAnterior = objeto.lim_cred_anterior;
        this._disCredAnterior = objeto.dis_cred_anterior;
        this._fechaAprobacion = objeto.fecha_aprobacion;
        this._acreditacionPara = objeto.acreditacion_para;
    }

    override async guardar(service: AcreditacionService): Promise<IResponse> {
        return await service.post(this.serverJson);
    }

    override async actualizar(
        service: AcreditacionService
    ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    override async eliminar(service: AcreditacionService): Promise<IResponse> {
        return await service.delete(this.id);
    }
}
